<template>
  <header class="header-global">
    <base-nav class="navbar-main" type expand>
      <router-link slot="brand" class="navbar-brand" to="/">
        <night-morning-logo width="250px" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand">
          <router-link to="/">
            <night-morning-logo icon-color="#72499d" />
          </router-link>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <!-- Mobile ONLY (Hamburger) -->
      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <li class="nav-item d-lg-none">
          <router-link class="nav-link" to="/contact">
            <i class="fa fa-users"></i>
            <span class="nav-link-inner--text">Contact</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/portfolio">
            <i class="fa fa-users d-lg-none"></i>
            <span class="nav-link-inner--text">Portfolio</span>
          </router-link>
        </li>
      </ul>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item d-lg-none">
          <a
            class="nav-link nav-link-icon"
            href="https://www.facebook.com/nightmorninggames"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Connect via Facebook"
          >
            <i class="fa fa-facebook-square"></i>
            <span class="nav-link-inner--text d-lg-none">Facebook</span>
          </a>
        </li>

        <li class="nav-item d-none d-lg-block ml-lg-4">
          <connect-button></connect-button>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
import NightMorningLogo from "@/views/components/icons/NightMorningLogo";
import ConnectButton from "@/views/components/ConnectButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    NightMorningLogo,
    ConnectButton
  }
};
</script>
<style scoped>
</style>